import { SetStateAction, Dispatch, MutableRefObject } from 'react';
import { IProduct } from 'src/common/types/CatalogType';
import catalogService from 'src/services/catalogService';

const ONE_ITEM = 1;

export const isDefined = (item: any) => typeof item !== 'undefined';

export const hasItems = (items?: any[] | undefined) =>
  !!items && !!items.length;

export const hasOne = (item: any[]) => item.length === ONE_ITEM;

export const generateCacheKey = (
  skus: string[],
  page?: number,
  uf?: string,
) => {
  switch (true) {
    case hasOne(skus) && isDefined(uf): {
      return `/${uf}/product/${skus[0]}`;
    }

    case hasOne(skus) && !isDefined(uf): {
      return `/product/${skus[0]}`;
    }

    case isDefined(page) && isDefined(uf): {
      return `/${uf}/page/${page}`;
    }

    case isDefined(page) && !isDefined(uf): {
      return `/page/${page}`;
    }

    default: {
      return '';
    }
  }
};

export const fetcher = (skus: string[], uf?: string): Promise<IProduct[]> =>
  hasItems(skus)
    ? catalogService.getProducts(skus, uf).then((res) => res.products)
    : Promise.resolve([]);

export interface ICache {
  [key: string]: IProduct[];
}

export interface IState {
  products: IProduct[];
  isLoading: boolean;
  hasError: boolean;
}

export const unableToGetProducts =
  () => (stateSetter: Dispatch<SetStateAction<IState>>) =>
    stateSetter({ products: [], hasError: false, isLoading: false });

export const productsFoundOnCache =
  (products: IProduct[]) => (stateSetter: Dispatch<SetStateAction<IState>>) =>
    stateSetter({
      products,
      hasError: false,
      isLoading: false,
    });

export const startLoadingProducts =
  () => (stateSetter: Dispatch<SetStateAction<IState>>) =>
    stateSetter({ products: [], hasError: false, isLoading: true });

export const productsFoundOnAPI =
  (cacheKey: string, products: IProduct[], shouldCancel: boolean) =>
  (
    stateSetter: Dispatch<SetStateAction<IState>>,
    cacheRef: MutableRefObject<ICache>,
  ) => {
    cacheKey && (cacheRef.current[cacheKey] = products);
    !shouldCancel &&
      stateSetter({ products, hasError: false, isLoading: false });
  };

export const retrieveProductsFailed =
  (shouldCancel: boolean) => (stateSetter: Dispatch<SetStateAction<IState>>) =>
    !shouldCancel &&
    stateSetter({ products: [], hasError: true, isLoading: false });
